<script>
  import page from 'page';
  import APIClient from '../state-charts/api-client';
  import ListWithSelect from './components/ListWithSelect.svelte';
  import Dialog from '../lib/components/Dialog.svelte';

  import session from '../lib/session';

  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import { show_message } from '../lib/flash';

  export let page_state;
  export let init_switcher;

  let service1;
  let service2;
  let service3;

  let dialog = false;

  // let list_items = [
  //     { name: "WorkPilots Finland", value: "", active: true },
  //     { name: "WorkPilots Sweden", value: "", active: false }
  // ];

  export let list_items;
  let selected_service;

  let dialog_title;
  let dialog_content;
  let clicked_id;

  // utility functions -------------------------------------------------------- //

  const handle_register = () => {
    page_state = true;
  };

  const switch_to_merchant = async () => {
    await APIClient.switch_to_merchant({ merchant_uuid: clicked_id });
  };

  let menu_label_switch_service;
  let you_are_registered;
  let reg_anoth_serv;
  let btn_cancel;
  let btn_yes;
  let dialog_first;
  let dialog_last;

  const create_switch_dialog = () => {
    let target = document.querySelector('.switch-dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'switch-message',
        title: dialog_title,
        content: dialog_content,
        buttons: [
          {
            label: btn_cancel,
            action: () => {
              dialog.close();
              init_switcher();
            },
            classes: [],
          },
          {
            label: btn_yes,
            id: "yes_switch",
            action: async () => {
              await switch_to_merchant();
              show_message(t9n(TS.HOME_SWITCH_MERCHANT_MESSAGE, $session.merchant.service.selection_name), 'success');
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  const format_dialog_content = () => {
    for (let i = 0; i < list_items.length; i++) {
      if (list_items[i].merchant_uuid === clicked_id) {
        selected_service = list_items[i].name;
      }
    }
    dialog_content = t9n(TS.SWITCHER_DIALOG_CONTENT_FIRST, selected_service);
  };

  let toggle_dialog = () => {
    format_dialog_content();
    let dialog = create_switch_dialog();
    dialog.open();
  };

  const translate_texts = () => {
    menu_label_switch_service = t9n(TS.MENU_LABEL_SWITCH_SERVICE);
    you_are_registered = t9n(TS.SERVICE_SWITCHER_REGISTERED);
    reg_anoth_serv = t9n(TS.SERVICE_SWITCHER_ANOTHER_BTN);
    btn_cancel = t9n(TS.TXT_CANCEL);
    btn_yes = t9n(TS.TXT_YES);
    dialog_first = t9n(TS.SWITCHER_DIALOG_CONTENT_FIRST);
    dialog_title = t9n(TS.TXT_ARE_YOU_SURE);
    // dialog_last = t9n(TS.SWITCHER_DIALOG_CONTENT_LAST);
  };

  $: if (!!$session) translate_texts();

</script>

<div class="fade-in">
  <div style="text-align: center;">
    <h1 style="margin-bottom: 25px" class="mdc-typography--headline5">
      {menu_label_switch_service}
    </h1>
  </div>

  <div class="list-margin">
    {#if list_items.length > 0}
      <ListWithSelect
        label={you_are_registered}
        on_row_click={toggle_dialog}
        bind:clicked_id
        bind:items={list_items} />
    {/if}
  </div>

  <div style="text-align: center; margin-top: 25px">
    <!-- Service list loop's place -->
  </div>

  <div style="text-align: center; margin: 25px">
    <button
      id="reg_anoth_serv"
      on:click|preventDefault={handle_register}
      class="mdc-button mdc-button--unelevated margin-5 change-pw">
      <span class="mdc-button__ripple" />
      {reg_anoth_serv}
    </button>
  </div>

  <div class="switch-dialog" />
</div>

<style>
  .list-margin {
    /*margin-left: 90px;*/
    text-align: center;
  }

  /* Mobile Mode
    ************************************/
  @media screen and (max-width: 768px) {
    .list-margin {
      margin-left: 20px;
      overflow-x: auto;
    }
  }
</style>
